<template>
  <div class="isis-tabs">
    <md-tabs
      md-alignment="left"
      @md-changed="onChange"
      :md-active-tab="tabActive || null"
    >
      <template slot="md-tab" slot-scope="{ tab }">
        {{ $t(tab.label) }}
        <i class="badge" v-show="tab.data.badge">{{ tab.data.badge }}</i>
      </template>
      <slot name="content"></slot>
    </md-tabs>
  </div>
</template>

<script>
export default {
  name: "isis-tabs",
  props: ["tabActive"],
  data() {
    return {
      curTabId: ""
    };
  },
  methods: {
    onChange(tabId) {
      this.curTabId = tabId;
      this.$emit("on-tab-change", tabId);
    }
  },
  provide() {
    return {
      curTabId: this.curTabId
    };
  }
};
</script>

<style lang="scss">
.isis-tabs {
  .md-tabs-navigation {
    margin-top: 0;
    box-shadow: none;
    background-color: transparent;

    button {
      .md-button-content {
        color: #8a8c8e !important;
        font-weight: 500;
        text-transform: none;
      }

      &.md-active {
        border-bottom: 2px solid #9c27b0;

        .md-button-content {
          background: transparent;
          color: #9c27b0 !important;
        }
      }
    }
  }

  .md-tabs-content {
    background: transparent;
  }
}
.badge {
  height: 24px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  right: 0;
  background: #9c27b0;
  border-radius: 100%;
  color: #fff;
  font-style: normal;
  font-family: "Roboto Mono", monospace;
}
</style>
<style scoped>
.md-button:not(.md-just-icon) .md-button-content i {
  font-size: 11px !important;
}
</style>
